
<!-- <div class="container mt-2 pb-4" style="margin-bottom: 120px;"> -->
<div class="container mt-2 pb-4" [ngStyle]="selectedMeeting.meetingCat === 'CR' ? {'margin-bottom': '120px'} : {}">
  <div class="row">
    <div class="card border p-0 overflow-hidden">
      <div class="d-flex p-3">
        <div class="d-flex flex-column">
          <div class="btn_selection-back"  >
            <ion-icon style="font-size: 22px;padding: 2px;vertical-align: middle;color: black;" name="arrow-back-outline" (click)="backToMettingView()"></ion-icon>
            <ion-icon (click)="click_reload()" [ngClass]="{'rotate':rotate == true}" style="font-size: 18px;color: #385767; margin-left: 30px;vertical-align: middle;" name="refresh-outline"></ion-icon>
            <span (click)="click_reload()"  style="margin-left: 5px; font-size: 13px; color: #385767;vertical-align: middle;" >{{'COMMON.REFRESH' | translate}} <ion-badge style="width: 21px; padding: 3px; background: #1C9C84; vertical-align: middle;border-radius: 50%;">{{counter}}</ion-badge>
              </span>            
          </div>   
          <div class="t mt-2">{{selectedMeeting.eventLabel}}</div>
          <div class="t-small">{{selectedMeeting.eventName}}</div>
        </div>
        <div class="extra d-flex flex-column align-items-end">
          <span class="t-strong">{{selectedMeeting.eventCode}}</span>
          <span class="t-smaller">{{selectedMeeting.eventLocalDate}}</span>
        </div>
      </div>
      <div class="race-content border-top">
        <ul class="list-group list-group-flush">
          <li class="list-group-item" *ngFor="let odd of selectionOdds; index as i">
            <div class="number bg-transparent">{{odd.selectionNumber}}</div>
            <div class="info">
              <div class="t">{{odd.name}}</div>
            </div>
            <div class="extra" *ngIf="odd.feedId != 44">
              <button disabled *ngIf="odd.status!='S' && !(odd.priceOdds.priceFraction!=undefined && selectedMeeting.cat=='O' && odd.priceOdds.priceDecimal != '' && odd.priceOdds.priceDecimal != null && odd.status != 'N') && odd.lastOddDec!=1"
              class="btn btn-tertiary mr-1">{{odd.lastOddDec}}</button>
             
              <button *ngIf="odd.status!='S' && !(odd.priceOdds.priceFraction!=undefined && selectedMeeting.cat=='O' && odd.priceOdds.priceDecimal != '' && odd.priceOdds.priceDecimal != null && odd.status != 'N') && odd.lastOddDec!=1"
               class="btn btn-tertiary" (click)="setSPOdd(odd)" [ngClass]="{'btn-tertiaryActive':odd.clicked == true}">{{'COMMON.BET' | translate}}</button>

              <button *ngIf="odd.status!='S' && odd.priceOdds.priceFraction!=undefined && selectedMeeting.cat=='O' && odd.priceOdds.priceDecimal != '' && odd.priceOdds.priceDecimal != null && odd.status != 'N'" 
              class="btn btn-tertiary" (click)="setSPOdd(odd)" [ngClass]="{'btn-tertiaryActive':odd.clicked == true}">{{odd.priceOdds.priceDecimal}}</button>

              <button *ngIf="odd.status=='S'" 
              class="btn btn-tertiary-red" style="padding-left: 6px;padding-right: 6px;" [ngClass]="{'btn-tertiaryActive':odd.clicked == true}">{{'COMMON.SUSPEND' | translate}}</button>
            </div>
            <div class="extra" *ngIf="odd.feedId == 44">
              <button disabled *ngIf="(odd.priceOdds.priceFraction!=undefined && selectedMeeting.cat=='O' && odd.priceOdds.priceDecimal != '' && odd.priceOdds.priceDecimal != null && odd.status != 'N') && odd.lastOddDec!=1 && odd.lastOddDec!=0 && odd.priceOdds.priceDecimal != 1 && odd.status!='S'"
              class="btn btn-tertiary mr-1">{{odd.lastOddDec}}</button>

              <button *ngIf="(odd.priceOdds.priceFraction!=undefined && selectedMeeting.cat=='O' && odd.priceOdds.priceDecimal != '' && odd.priceOdds.priceDecimal != null && odd.status != 'N') && odd.lastOddDec!=1 && odd.lastOddDec!=0 && odd.priceOdds.priceDecimal != 1 && odd.status!='S'"
               class="btn btn-tertiary" (click)="setSPOdd(odd)" [ngClass]="{'btn-tertiaryActive':odd.clicked == true}">{{'COMMON.BET' | translate}}</button>

               <button *ngIf="odd.status=='S' || odd.priceOdds.id == -1 || odd.lastOddDec == 0 || odd.priceOdds.priceDecimal == 1" 
              class="btn btn-tertiary-red" style="padding-left: 6px;padding-right: 6px;" [ngClass]="{'btn-tertiaryActive':odd.clicked == true}">{{'COMMON.SUSPEND' | translate}}</button>
            </div>
          </li>
          
        </ul>
      </div>
    </div>
  </div>
</div>